export enum EventEnum {
  Login = "login",
  ReportExport = "report_exported",
  siteAdded = "site_added",
  cloudUserAdded = "cloud_user_added",
  appUserAdded = "app_user_added",
}
